/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class PrintAPI
 * @hideconstructor
 * @classdesc  API class that is used to print an asset
 */
define([], () => {
	class PrintAPI {

		/**
		 * @public
		 * @function PrintAPI#print
		 * @param {Object} content of the page to print
		 * @param {Object} pageOptions.pageSize size of the page eg: letter/legal/A4/Tabloid
		 * @param {boolean}  pageOptions.printFilters boolean value to represent whether to include filters or not
		 * @description prints the current asset from the view
		 */
		print() { }

		/**
		 * @function PrintAPI#registerContent
		 * @description Registers the asset type for printing
		 * @param {string} type type of the current asset
		 * @param {Object} api instance of the asset api
		 */
		registerContent() {}
	}

	return PrintAPI;
});
